import {ReceiptNotification} from '../../services/notifications/notificationModel';

export interface NotificationState {
  items: ReceiptNotification[];
  unreadCount: number;
  loading: boolean;
  error: string | null;
  connectionStatus: 'connecting' | 'live' | 'reconnecting' | 'offline';
  hasMore: boolean;
  loadingMore: boolean;
  markingRead: boolean;
  refresh: () => Promise<void>;
  loadMore: () => Promise<void>;
  markRead: (id: number) => Promise<void>;
  markAllRead: () => Promise<void>;
}

const unavailable = async () => { throw new Error('Notifications require an active session'); };

export const defaultNotificationState: NotificationState = {
  items: [],
  unreadCount: 0,
  loading: false,
  error: null,
  connectionStatus: 'offline',
  hasMore: false,
  loadingMore: false,
  markingRead: false,
  refresh: unavailable,
  loadMore: unavailable,
  markRead: unavailable,
  markAllRead: unavailable,
};
